import React from 'react';

const Product = () => {
    return (
        <div className="min-h-screen bg-gray-900">
            <iframe 
                src="/product_list.html" 
                title="Product List"
                className="w-full h-screen"
                style={{ border: 'none' }}
            />
        </div>
    );
};

export default Product;

